import { gql } from '@apollo/client';

export const GET_JOB = gql`
  query GetJob($_id: ID!) {
    getJob(_id: $_id) {
      _id
      failReason
      lastFinishedAt
      result
    }
  }
`;
